// @ts-strict
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LMRouteComponentService } from '@services/index';
import {
  FieldOperatorChangedEvent,
  LMOperatorInfo,
} from "@modal/field-picker/lm-field-picker";
import { LMFieldPickerService } from "@app/components";
import { LMGlobalPersonalizationService } from "@app/states";


@Component({
  selector: 'lm-field-picker-period-operator',
  standalone: false,
  templateUrl: './lm-field-picker-period-operator.component.html',
  styleUrls: [ './lm-field-picker.component.scss' ],
  providers: [ LMRouteComponentService ]
  })
export class LMFieldPickerPeriodOperatorComponent implements OnInit {

  @Input() uiFieldSpec!:  UIFieldSpec;
  @Input() operatorInfo!: LMOperatorInfo;
  @Input() validPeriods!: Array<string>;

  @Output() operatorChangedEvent = new EventEmitter<FieldOperatorChangedEvent>();

  useCompactFormLayout = false;
  validPeriodsForMeasuresOnly = [
    { value: 'period', label: Soho.Locale.translate('FieldPicker_periodOption_label') },
    { value: 'week', label: Soho.Locale.translate('FieldPicker_weekOption_label') },
    { value: 'month', label: Soho.Locale.translate('FieldPicker_monthOption_label') },
    { value: 'quarter', label: Soho.Locale.translate('FieldPicker_quarterOption_label') },
    { value: 'year', label: Soho.Locale.translate('FieldPicker_yearOption_label') },
  ];

  // validPeriodsForMeasuresOnly
  constructor(
    private lmFieldPickerService: LMFieldPickerService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
  ) {
    // @ts-ignore
    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout ? this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout : false;
  }
  ngOnInit() {
    this.setValidPeriodsForMeasuresOnly();
  }
  onOperatorChange(id: string) {
    const info = this.operatorInfo.periodOperatorInfo;

    if (!info) {
      return;
    }

    if ('periodCategory' === id || 'periodOperator' === id || 'periodPriorNext' === id) {
      this.lmFieldPickerService.defaultPeriodFrom(info);
      this.lmFieldPickerService.defaultPeriodTo(info);
    } else if ('yearOperator' === id) {
      if (!info.yearInfo?.yearOperator) {
        info.yearInfo.year = undefined;
      } else if (info.yearInfo.year === undefined || info.yearInfo.year == 0) {
        info.yearInfo.year = 1;
      }
    }

    const event:FieldOperatorChangedEvent = {
      eventType: 'period',
      uiFieldSpec: this.uiFieldSpec,
      operatorInfo: this.operatorInfo
    };

    this.operatorChangedEvent.emit(event);
  }

  private setValidPeriodsForMeasuresOnly() {
    if (this.validPeriods?.length > 0) {
      const validPeriodsCopy = [];
      this.validPeriodsForMeasuresOnly.forEach((p, index) => {
        const validIndex = this.validPeriods.findIndex(v => v.toLowerCase() === p.value.toLowerCase());
        if (validIndex > -1) {
          validPeriodsCopy.push(p);
        }
      });
      this.validPeriodsForMeasuresOnly = validPeriodsCopy;
    }
  }
}

